export default __webpack_public_path__ + "static/image-mv_cases@2x-6972c80be7d3d293ca72a8b950c3bc3b.jpg";